/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { StorageGatewayDetails } from '../models/StorageGatewayDetails';

export class StorageGateway {
  /**
  * List of identifiers of the dlsg policies associated with the storage gateway.
  */
  'dlsgPolicyIds': Array<string>;
  /**
  * The region where the storage gateway is located.
  */
  'region': string;
  'storageGatewayDetails': StorageGatewayDetails;
  /**
  * Path to the deletion manifest file for the storage gateway.
  */
  'deletionManifestPath': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "dlsgPolicyIds",
      "baseName": "dlsgPolicyIds",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "storageGatewayDetails",
      "baseName": "storageGatewayDetails",
      "type": "StorageGatewayDetails",
      "format": ""
    },
    {
      "name": "deletionManifestPath",
      "baseName": "deletionManifestPath",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return StorageGateway.attributeTypeMap;
  }

  public constructor() {
  }
}

